export const ViewByCategory = 'category' as const;
export const ViewByMonth = 'month' as const;
export type ViewByOptions = typeof ViewByCategory | typeof ViewByMonth;
